export const SET_CONTENT_VIEWED_INDICES = 'SET_CONTENT_VIEWED_INDICES';
